// test2322
(2322 && 0);
